const MS_PER_DAY = 24 * 60 * 60 * 1000;

function pad2(n) {
  return String(n).padStart(2, "0");
}

function formatDays(days) {
  if (days > 99) return String(days);
  return pad2(days);
}

function parseEventStart(root) {
  const raw = (root.dataset.eventStart || "").trim();
  if (!raw) return NaN;
  const t = Date.parse(raw);
  return t;
}

/**
 * Optional: set data-ecd-window-days="10" on the section to show the block only
 * in the last N days before the event. Omit (or "0") to always show the countdown
 * until the event starts.
 */
function parseWindowDays(root) {
  const raw = (root.dataset.ecdWindowDays || "").trim();
  if (!raw) return 0;
  const n = Number.parseInt(raw, 10);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

function shouldShowModule(now, eventStartMs, windowDays) {
  if (now >= eventStartMs) return false;
  if (!windowDays) return true;
  const windowMs = windowDays * MS_PER_DAY;
  return now >= eventStartMs - windowMs;
}

function tick(root, eventStartMs) {
  const digits = {
    days: root.querySelector('[data-ecd="days"]'),
    hours: root.querySelector('[data-ecd="hours"]'),
    minutes: root.querySelector('[data-ecd="minutes"]'),
    seconds: root.querySelector('[data-ecd="seconds"]'),
  };

  let intervalId;

  const update = () => {
    const now = Date.now();
    if (now >= eventStartMs) {
      window.clearInterval(intervalId);
      root.remove();
      return;
    }

    let remaining = eventStartMs - now;
    const days = Math.floor(remaining / 86400000);
    remaining %= 86400000;
    const hours = Math.floor(remaining / 3600000);
    remaining %= 3600000;
    const minutes = Math.floor(remaining / 60000);
    remaining %= 60000;
    const seconds = Math.floor(remaining / 1000);

    if (digits.days) digits.days.textContent = formatDays(days);
    if (digits.hours) digits.hours.textContent = pad2(hours);
    if (digits.minutes) digits.minutes.textContent = pad2(minutes);
    if (digits.seconds) digits.seconds.textContent = pad2(seconds);
  };

  update();
  intervalId = window.setInterval(update, 1000);
}

export function initEventCountdown() {
  const roots = document.querySelectorAll(".event-countdown");
  if (!roots.length) return;

  roots.forEach((root) => {
    const eventStartMs = parseEventStart(root);
    if (Number.isNaN(eventStartMs)) {
      root.remove();
      return;
    }

    const windowDays = parseWindowDays(root);
    const now = Date.now();
    if (!shouldShowModule(now, eventStartMs, windowDays)) {
      root.remove();
      return;
    }

    tick(root, eventStartMs);
  });
}
